import React from 'react';
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";
import {hashHistory} from "react-router";

import {toggleChangeLayoutPopup, sendLayoutChangeOnSqft} from "../../actions/sqftFunctions";
import Analytics from './../../analytics';
import {LayoutAbbreviations} from "../kvComponent/core/constants";
import NavigationRequests from "../visComponents/navigation/navigationRequests";
import {setActiveFeature, setCameFromPage, toggleSelectionFeatureInfo} from "../../actions/actionFunctions";
import {getCurrentLayout} from "../appLayout";
import CountertopGroup from "../kvComponent/core/parts/countertopGroup";
import {setNewLayout, setRoomLayouts} from "../sqft/components/navigation/menu/countertop/toolMenu/SqftNavLayouts";

class ChangeLayoutPopup extends NavigationRequests {

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.changeLayoutPopupOpened && !this.props.changeLayoutPopupOpened) {
      document.body.classList.add('body--apply-popup');
    }
  }

  handleApply = (confirm) => {
    Analytics.sendClickEvent('change-layout-popup-apply-' + (confirm ? 'yes': 'no'));
    this.props.toggleChangeLayoutPopup(false);
    document.body.classList.remove('body--apply-popup');
    if (confirm) {
      this.props.sendLayoutChangeOnSqft(true);
      if (!this.props.applyLayoutOnSqft) {
        setTimeout(() => {
          this.props.setCameFromPage("sqft");
          hashHistory.push(this.props.cameFromPage || "materials");
        }, 0)
      }
      const layoutType = LayoutAbbreviations.findIndex(abbr => abbr === this.props.layoutToApply);
      //this.changeLayout(layoutType); // todo check if this is needed
      this.setNewActiveFeatureInfo();
      setNewLayout(this.props.layoutToApply);
      setRoomLayouts(layoutType)
    }
  };

  setNewActiveFeatureInfo = () => {
    const layout = getCurrentLayout();
    if (layout.qtCategories) {
      const qtActiveCategory = layout.qtCategories.find(qtCategory => qtCategory.name === this.props.qtActiveCategory);
      if (qtActiveCategory
        && qtActiveCategory.qtCategoryHasBeenChanged
        && this.props.selectionFeatureInfo
        && document.kvConfig.visualizerType === "Kitchen"
        && this.props.selectionFeatureInfo.partId === "center_island_countertop"
        && !qtActiveCategory.subParts.some(sPart => sPart.part.partId === "center_island_countertop")) {
        const countertopParent = layout.parts[CountertopGroup.id];
        if (countertopParent) {
          const countertopGroup  = countertopParent.subParts().find(cPart => cPart.part.partId === "countertop");
          if (countertopGroup) {
            const name = this.props.selectionFeatureInfo.getCountertopGroupsSplittedFeatureName();
            let newFeature = countertopGroup.part.navigationSubItems().find(navItem => {
              return navItem.part.getCountertopGroupsSplittedFeatureName() === name
            });
            if (newFeature) {
              this.props.toggleSelectionFeatureInfo(newFeature.part);
              this.props.setActiveFeature(newFeature.part);
            } else {
              if (countertopGroup.part && countertopGroup.part.activeFeature) {
                countertopGroup.part.firstClick[this.props.activeQuoteIndex] = true;
              }
              this.props.toggleSelectionFeatureInfo(null);
            }
          }
        }
      }
    }
  };

  render() {
    return this.props.changeLayoutPopupOpened ? (
      <div className="overlay overlay--confirm">
        <div className="change-layout-popup">
          <div className="change-layout-popup-header">
          <h3 className="change-layout-popup-header__title">
            <FormattedMessage id="changeLayoutPopup.title"/>
          </h3>
          <button className="apply-popup-header__close ui-close" onClick={() => this.props.toggleChangeLayoutPopup()}/>
          </div>
          <div className="change-layout-popup-body">
            <div className="change-layout-popup-body__text">
              <FormattedMessage id="changeLayoutPopup.message"/>
            </div>
            <div className={"change-layout-popup-body__image change-layout-popup-body__image--" + this.props.layoutToApply}/>
          </div>
          <div className="change-layout-popup-buttons">
            <button className="ui-button2 ui-button2--blue ui-button3" onClick={() => this.handleApply(false)}>
              <FormattedMessage id="changeLayoutPopup.buttonNo"/>
            </button>
            <button className="ui-button2 ui-button2--green ui-button3" onClick={() => this.handleApply(true)}>
              <FormattedMessage id="changeLayoutPopup.buttonYes"/>
            </button>
          </div>
        </div>
      </div>
    ) : null
  }
}

const mapStateToProps = (store) => {
  return {
    changeLayoutPopupOpened: store.sqftState.changeLayoutPopupOpened,
    layoutToApply: store.sqftState.layoutToApply,
    applyLayoutOnSqft: store.sqftState.applyLayoutOnSqft,
    qtActiveCategory: store.qtState.qtActiveCategory,
    selectionFeatureInfo: store.selectionState.selectionFeatureInfo,
    activeQuoteIndex: store.quotesState.activeQuoteIndex,
    cameFromPage: store.cartState.cameFromPage,
  };
};

export default connect(mapStateToProps, {
  toggleChangeLayoutPopup,
  sendLayoutChangeOnSqft,
  toggleSelectionFeatureInfo,
  setActiveFeature,
  setCameFromPage,
})(ChangeLayoutPopup);
